<template>
<v-dialog v-model="dialog"
	persistent
	max-width="500px"
>
	<v-form v-model="valid">
		<v-card>
			<v-card-title>
				<span class="headline">{{$t('templates.dialog_users_caption')}}</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12 d-flex>
							<v-text-field
								:label="$t('common.email')"
								:error-messages="emailError"
								:rules="emailRules"
								v-model="new_user_email"
							/>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn color="red darken-1" flat @click="cancel">{{$t('common.close')}}</v-btn>
				<v-btn color="green darken-1" flat @click="addUser">
					{{$t('templates.dialog_users_submit')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-form>
</v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { TEMPLATE_USER } from '../../constants'

const { mapActions, mapState } = createNamespacedHelpers('users')

export default {
	props: [
		'value'
	],
	data(vm) {
		return {
			valid: false,
			new_user_email: ''
		}
	},
	computed: {
		...mapState(['emailError']),
		emailRules() {
			return [
				v => !!v || this.$t('common.email_required'),
				v => /.+@.+/.test(v) || this.$t('common.email_valid')
			]
		},
		dialog: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {
		...mapActions(['checkEmail']),
		cancel() {
			this.dialog = false
			this.$store.state.users.emailError = null
		},
		addUser() {
			if(this.valid) {
				TEMPLATE_USER.email = this.new_user_email
				this.checkEmail({ ...TEMPLATE_USER })
			}
		}
	},
	watch: {
		new_user_email() {
			this.$store.state.users.emailError = null
		}
	}
}
</script>

